import React, { useEffect, useState } from "react";
import "./index.css";
// MATERIAL ---------------------------------------------------------------->
import {
  Grid,
  TextField,
  Link,
  Button,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@material-ui/core";

// <---------------------------------------------------------------- MATERIAL

// FORMIK ---------------------------------------------------------------->
import * as Yup from "yup";
import { useFormik } from "formik";
// <---------------------------------------------------------------- FORMIK
// SERVICES ---------------------------------------------------------------->
import { toast } from "react-toastify";
import authentication from "../../../services/authentication";
import listados from "../../../services/listados";
import seleccionables from "../../../services/seleccionables";
// <---------------------------------------------------------------- SERVICES

export default function Register(props) {
  const { classes, changeForm } = props;
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [loadStates, setLoadStates] = useState(true);

  useEffect(() => {
    seleccionables
      .countries()
      .then((result) => {
        setCountries(result);
      })
      .catch((error) => {
        console.log(error);
      });

    seleccionables
      .states("44")
      .then((result) => {
        setStates(result);
        setLoadStates(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getMunicipalities = (contryId, stateId) => {
    seleccionables
      .municipalities(contryId, stateId)
      .then((result) => {
        setMunicipalities(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formik = useFormik({
    initialValues: {
      names: "",
      surnames: "",
      documentType: "",
      dni: "",
      email: "",
      password: "",
      country: "44",
      state: "",
      municipality: "",
    },
    validationSchema: Yup.object({
      names: Yup.string().required("Nombres obligatorios"),
      surnames: Yup.string().required("Apellidos obligatorios"),
      documentType: Yup.string().required(
        "El tipo de documento es obligatorio"
      ),
      dni: Yup.string()
        .matches(/^[0-9]*$/g, "Solo se aceptan números")
        .required("Número de documento obligatorio"),
      mobilePhone: Yup.string()
        .matches(
          /^[0-9]{10}$/,
          "Lo Sentimos, Por favor revisa tu número de teléfono."
        )
        .required("El número de teléfono es obligatorio"),
      email: Yup.string()
        .email(
          "El correo electrónico es invalido, verifica que no tenga espacios al final."
        )
        .required("El email es obligatorio"),
      password: Yup.string().required("Contraseña obligatoria"),
      state: Yup.string().required("El departamento es obligatorio"),
      municipality: Yup.string().required("La ciudad es obligatoria"),
    }),
    onSubmit: async (formData) => {
      console.log(formData);
      formData.dni = formData.dni.trim();
      try {
        formData.countryText = countries.find(
          (country) => country.id === formData.country
        ).nombre;
        formData.stateText = states.find(
          (state) => state.id === formData.state
        ).nombre;
        formData.municipalityText = municipalities.find(
          (municipality) => municipality.id === formData.municipality
        ).municipality;
        formData.email = formData.email.toLowerCase();
        authentication
          .signUpWithEmailAddressAndPassword(
            formData.email,
            formData.password,
            formData
          )
          .then((result) => {
            toast.success(result);
            formik.resetForm();
          })
          .catch((error) => {
            toast.error(error);
            console.log(error);
          });
      } catch (error) {
        toast.error(error);
        console.log(error);
      }
    },
  });

  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
      className={classes.form}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            autoComplete="fname"
            name="names"
            variant="outlined"
            required
            fullWidth
            id="names"
            label="Nombres"
            autoFocus
            value={formik.values.names}
            onChange={formik.handleChange}
            error={
              formik.errors.names === undefined ||
              formik.touched.names === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.names && formik.touched.names
                ? formik.errors.names
                : null
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            id="surnames"
            label="Apellidos"
            name="surnames"
            autoComplete="snames"
            value={formik.values.surnames}
            onChange={formik.handleChange}
            error={
              formik.errors.surnames === undefined ||
              formik.touched.surnames === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.surnames && formik.touched.surnames
                ? formik.errors.surnames
                : null
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            variant="outlined"
            error={
              formik.errors.documentType === undefined ||
              formik.touched.documentType === undefined
                ? false
                : true
            }
            fullWidth
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              Tipo de documento
            </InputLabel>
            <Select
              native
              name="documentType"
              value={formik.values.documentType}
              onChange={formik.handleChange}
              label="Tipo de documento"
              size="small"
            >
              <option aria-label="None" value="" />
              {Object.values(listados.documentTypes).map((dt, index) => {
                return (
                  <option aria-label={dt} value={index} key={index}>
                    {dt}
                  </option>
                );
              })}
            </Select>
            {formik.errors.documentType && formik.touched.documentType ? (
              <FormHelperText>{formik.errors.documentType}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            id="dni"
            label="Número de documento"
            name="dni"
            autoComplete="dni"
            value={formik.values.dni}
            onChange={formik.handleChange}
            error={
              formik.errors.dni === undefined ||
              formik.touched.dni === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.dni && formik.touched.dni ? formik.errors.dni : null
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            variant="outlined"
            error={
              formik.errors.state === undefined ||
              formik.touched.state === undefined
                ? false
                : true
            }
            fullWidth
          >
            <InputLabel>Departamento de residencia</InputLabel>
            <Select
              native
              name="state"
              value={formik.values.state}
              onChange={(event) => {
                getMunicipalities(formik.values.country, event.target.value);
                formik.setFieldValue("state", event.target.value);
                formik.setFieldValue("municipality", "");
              }}
              label="Departamento de residencia"
              disabled={loadStates}
            >
              <option
                aria-label="None"
                value=""
                disabled={formik.values.state && true}
              />
              {states.map((state) => {
                return (
                  <option
                    aria-label={state.nombre}
                    value={state.id}
                    key={state.id}
                  >
                    {state.nombre}
                  </option>
                );
              })}
            </Select>
            {formik.errors.state && formik.touched.state ? (
              <FormHelperText>{formik.errors.state}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            variant="outlined"
            error={
              formik.errors.municipality === undefined ||
              formik.touched.municipality === undefined
                ? false
                : true
            }
            fullWidth
          >
            <InputLabel>Ciudad de residencia</InputLabel>
            <Select
              native
              name="municipality"
              value={formik.values.municipality}
              onChange={(event) => {
                formik.setFieldValue("municipality", event.target.value);
              }}
              label="Ciudad de residencia"
              disabled={municipalities.length === 0}
            >
              <option
                aria-label="None"
                value=""
                disabled={formik.values.municipality && true}
              />
              {municipalities.map((municipality) => {
                return (
                  <option
                    aria-label={municipality.municipality}
                    value={municipality.id}
                    key={municipality.id}
                  >
                    {municipality.municipality}
                  </option>
                );
              })}
            </Select>
            {formik.errors.municipality && formik.touched.municipality ? (
              <FormHelperText>{formik.errors.municipality}</FormHelperText>
            ) : (
              ""
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            name="mobilePhone"
            label="Teléfono móvil"
            type="mobilePhone"
            id="mobilePhone"
            autoComplete="current-mobilePhone"
            value={formik.values.mobilePhone}
            onChange={formik.handleChange}
            error={
              formik.errors.mobilePhone === undefined ||
              formik.touched.mobilePhone === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.mobilePhone && formik.touched.mobilePhone
                ? formik.errors.mobilePhone
                : null
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={
              formik.errors.email === undefined ||
              formik.touched.email === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.email && formik.touched.email
                ? formik.errors.email
                : null
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            id="password"
            autoComplete="current-password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={
              formik.errors.password === undefined ||
              formik.touched.password === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.password && formik.touched.password
                ? formik.errors.password
                : null
            }
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Registrarse
      </Button>
      <Grid
        container
        direction="row"
        justifycontent="space-between"
        alignItems="center"
      >
        <Grid item xs={6}>
          <Link href="#" variant="body2" onClick={() => changeForm(3)}>
            Recuperar contraseña
          </Link>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <Link href="#" variant="body2" onClick={() => changeForm(0)}>
            ¿Ya estas registrado? Inicia sesión
          </Link>
        </Grid>
      </Grid>
    </form>
  );
}
